import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    satisfactionFormData: {},
    satisfactionSummaryData: {},
    satisfactionFormWithFilterData: {},
  },
  getters: {
    satisfactionFormData: (state) => state.satisfactionFormData,
    satisfactionSummaryData: (state) => state.satisfactionSummaryData,
    satisfactionFormWithFilterData: (state) => state.satisfactionFormWithFilterData,
  },
  actions: {
    createFormSatisfaction(context, params) {
      const { data } = params;
      return new Promise((resolve, reject) => {
        alice
          .createForm(data)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSatisfactionForm(context) {
      return new Promise((resolve, reject) => {
        alice
          .getForm()
          .then((response) => {
            const { data } = response.data;
            context.commit('setSatisfactionFormData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSatisfactionSummary(context) {
      return new Promise((resolve, reject) => {
        alice
          .getFormSummary()
          .then((response) => {
            const { data } = response.data;
            context.commit('setSatisfactionSummaryData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadSatisfactionWithFilter(context, params) {
      const { searchBody } = params;
      return new Promise((resolve, reject) => {
        alice
          .getFormWithFilter(searchBody)
          .then((response) => {
            const { data } = response.data;
            context.commit('setSatisfactionFormWithFilterData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    exportForm(context, params) {
      const { satisfactionExportBody } = params;
      return new Promise((resolve, reject) => {
        alice
          .exportForm(satisfactionExportBody)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setSatisfactionFormData(state, data) {
      Vue.set(state, 'satisfactionFormData', data);
    },
    setSatisfactionSummaryData(state, data) {
      Vue.set(state, 'satisfactionSummaryData', data);
    },
    setSatisfactionFormWithFilterData(state, data) {
      Vue.set(state, 'satisfactionFormWithFilterData', data);
    },
  },
};
